export default __webpack_public_path__ + "../staticImages/error404.jpg";